import _ from 'lodash';

const controllerDataId = 'comp-mockid';
export const createControllerData = (
  appDefinitionId: any,
  controllerType: any,
  name: any,
) => ({
  applicationId: appDefinitionId,
  controllerType,
  name,
  type: 'AppController',
  id: controllerDataId,
  settings: JSON.stringify({}),
});
export const buildTypeToDevCenterIdMap = ({ widgets }: any) =>
  _(widgets).mapValues('componentFields.appStudioFields.id').invert().value();
